import { resolveRoute } from 'vike/routing'
import type { PageContextServer } from 'vike/types'

export default (pageContext: PageContextServer) => {
  const resultWithId = resolveRoute('/user/@userId', pageContext.urlPathname)
  if (resultWithId.match) return resultWithId

  const resultWithoutId = resolveRoute('/user', pageContext.urlPathname)
  if (resultWithoutId.match) return resultWithoutId

  return false
}
